export const UserGuideRoutes = [
  {
    path: '/common/userGuide',
    name: 'User Guide',
    component: () => import('../views/common/UserGuide.vue'),
  },
];

export default UserGuideRoutes;
